import React from 'react';
import { Img, Thumb, ThumbInner } from './styles';

export const DEFAULT_THUMBNAIL_SIZE = 170;
export const LARGE_IMAGE_THUMBNAIL_SIZE = 320;

interface IThumbnailProp {
  src: HTMLImageElement['src'];
  link?: HTMLAnchorElement['href'];
  onClick?: () => void;
  containerStyle?: React.CSSProperties;
  size?: number;
}

const Thumbnail: React.FC<IThumbnailProp> = ({
  src,
  link,
  onClick,
  containerStyle,
  size = DEFAULT_THUMBNAIL_SIZE,
}) => {
  return (
    <Thumb href={link} onClick={onClick} target="_blank" $size={size}>
      <ThumbInner>
        <Img
          style={{ objectFit: 'contain', ...containerStyle }}
          src={src || ''}
        />
      </ThumbInner>
    </Thumb>
  );
};

export default React.memo(Thumbnail);
